/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
const getLocalStorageData = () => {
  const ignoreKeys = ['elevation', 'cognito'];
  const result = Object
    .keys(localStorage)
    .filter((item) => ignoreKeys.every((key) => !item.toLowerCase().includes(key)))
    .map((key) => ({
      key,
      data: localStorage[key],
    }));
  return result;
};

export default getLocalStorageData;
